/*
 * @Descripttion:
 * @Date: 2025-03-06 15:19:06
 */
import { ref, nextTick } from 'vue';
import { defineStore } from 'pinia';
import { BaseFormRef } from 'xrk-components';
import { ProjectDetail } from '../types/index';
import { formatter } from '@/utils';
import { projectDetailApi } from '../data-source/apis';
import { applyDftValues } from '../utils/apply-dft-values';

const createBaseData = () => {
  return {
    isPublish: null,
    txnStructInfo: {
      taxPattern: null,
      industryCompany: {
        id: null,
        companyName: '',
        phone: '',
        userName: '',
        label: ''
      },
      aspCompany: {
        id: null,
        companyName: '',
        phone: '',
        userName: '',
        label: ''
      },
      supplierCompany: {
        id: null,
        companyName: '',
        phone: '',
        userName: '',
        label: ''
      },
      backupSupplierCompanyList: [],
      isFictitious: null,
      participantType: null,
      taxType: null,
      taxBroadType: null
    },
    projectInfo: {
      id: null,
      pairAt: null,
      auditStatus: null,
      surveyId: null,
      surveyType: null,
      ctype: null,
      surveyName: '',
      surveyRemark: '',
      surveyCode: '',
      projectName: '',
      projectStatus: null,
      projectCode: '',
      projectRequire: '',
      startAt: '',
      endAt: '',
      areaId: [],
      areaList: [],
      payPassagewayCode: null,
      priceInfo: {
        price: null,
        cprice: null,
        settlementScale: null,
        cscale: null,
        totalPrice: null,
        totalPriceTax: null,
        platformScale: null,
        businessScale: null,
        techScale: null
      },
      sceneLevel1Id: null,
      sceneLevel2Id: null,
      sceneLevel3Id: null,
      workload: null,
      brief: '',
      productId: null,
      productName: '',
      medicalRepTag: null,
      sceneType: null,
      editStatus: null,
      sceneName: ''
    },
    execReqsInfo: {
      projectExpertise: null,
      isAuditAspVisible: null,
      isAuditIndustryVisible: null,
      isAuditCVisible: null,
      executorNameRule: null,
      certificated: null,
      qualsInfoList: [],
      isExpertiseAuth: null,
      expertiseType: null,
      expertiseAuthMode: null,
      shareExp: null,
      isDqTaskAudit: null,
      isMedicalRestrictions: null,
      isLimitIndividualMonthly: null,
      isLimitIndividualQuarterly: null,
      isShowDoctorInfoVerification: null,
      maxIndividualNumMonthly: null,
      maxIndividualNumQuarterly: null,
      isDoctorInfoVerification: null,
      isSignContract: null
    },
    reqsInfoConfig: {
      hasImgQuestion: null,
      hasLocationQuestion: null,
      hasNameQuestion: null,
      hasTargetNameQuestion: null,
      isShowDeptLimit: null
    },
    reqsInfo: {
      collectionType: null,
      isImageDeduplication: null,
      imageUploadRule: null,
      isTaskSubmitTimeShow: null,
      taskValidDays: null,
      isRtLocation: null,
      questionNameType: null,
      questionNameRule: null,
      isDeptLimit: null,
      deptIdList: [],
      targetNameRule: null,
      agreementServiceUploadType: null,
      agreementServiceUploadMode: null,
      feedback: [],
      _feedback: [],
      isDvAllRead: null,
      authType: null,
      szVisitType: null,
      zoneId: null,
      zoneName: '',
      zoneEnterpriseType: null,
      isAllowHoliday: null,

      _collectionType: [],
      _imageUploadRule: [],
      _agreementServiceUploadType: []
    },
    auditList: []
  };
};
const createTabNames = () => {
  return {
    1: {
      value: 1,
      flag: true,
      msg: '请确认完善信息是否填写完整'
    },
    2: {
      value: 2,
      flag: false,
      msg: '请确认需求设置是否填写完整'
    },
    3: {
      value: 3,
      flag: false,
      msg: '请确认风控信息是否填写完整'
    }
  };
};
export const useProjectDetailStore = defineStore(
  'projectDetail',
  () => {
    // 表格跳转标识
    const formIframeFalg = ref(0);
    const baseData = ref<ProjectDetail>(createBaseData());

    const formatNum100 = num => {
      if ([null, undefined, ''].includes(num)) return num;

      return num / 100;
    };
    /**
     * @description: 详情回显，数据格式化
     * @param {ProjectDetail} data
     * @returns {*}
     */
    const setBaseData = (data: ProjectDetail) => {
      // 执行要求 / 需求设置：无值时回退 *DftValue（0 算有值，[] 算无值，保留 DftValue）
      applyDftValues(data.execReqsInfo as Record<string, any>);
      applyDftValues(data.reqsInfo as Record<string, any>);

      const { projectInfo } = data;

      projectInfo.surveyName =
        projectInfo?.surveyName || projectInfo.projectName;

      projectInfo.priceInfo.platformScale = formatNum100(
        projectInfo.priceInfo.platformScale
      );
      projectInfo.priceInfo.businessScale = formatNum100(
        projectInfo.priceInfo.businessScale
      );
      projectInfo.priceInfo.techScale = formatNum100(
        projectInfo.priceInfo.techScale
      );
      projectInfo.priceInfo.price = formatNum100(projectInfo.priceInfo.price);
      projectInfo.priceInfo.cprice = formatNum100(projectInfo.priceInfo.cprice);
      projectInfo.priceInfo.cscale = formatNum100(projectInfo.priceInfo.cscale);
      projectInfo.priceInfo.settlementScale = formatNum100(
        projectInfo.priceInfo.settlementScale
      );

      projectInfo.priceInfo.totalPrice = +formatter.fillDecimal(
        projectInfo.priceInfo.orderPrice / 100,
        2,
        true
      );
      projectInfo.priceInfo.totalPriceTax = +formatter.fillDecimal(
        projectInfo.priceInfo.totalPrice *
          (1 + projectInfo.priceInfo.settlementScale / 100),
        2,
        true
      );

      // 问卷收集方式：1自答，2分享，3自答 + 分享;
      data.reqsInfo._collectionType =
        data.reqsInfo.collectionType === 3
          ? [1, 2]
          : [data.reqsInfo.collectionType].filter(Boolean);
      // C端上传图片方式：1现场直拍 + 图库，2现场直拍，3图库;
      data.reqsInfo._imageUploadRule =
        data.reqsInfo.imageUploadRule === 1
          ? [2, 3]
          : [data.reqsInfo.imageUploadRule].filter(Boolean);

      // 协定服务上传来源1ASP上传2C端上传3双方共同上传
      data.reqsInfo._agreementServiceUploadType =
        data.reqsInfo.agreementServiceUploadType === 3
          ? [1, 2]
          : [data.reqsInfo.agreementServiceUploadType].filter(Boolean);

      data.projectInfo.areaList =
        data.projectInfo?.areaList?.map(item => {
          const arr = [item.provinceId, item.cityId];
          return arr.filter(Boolean);
        }) || [];

      // 反馈内容字段处理
      data.reqsInfo._feedback = data.reqsInfo.feedback.map(
        (item: any, index) => {
          return {
            value: item,
            id: Date.now() + index
          };
        }
      );
      baseData.value = { ...baseData.value, ...data };
    };

    const initBaseData = () => {
      setBaseData(createBaseData());
      tabNames.value = createTabNames();
    };

    const clearStore = async () => {
      await initBaseData();
      nextTick(() => {
        window.sessionStorage.removeItem('projectDetail');
      });
    };

    const baseFormRef = ref<BaseFormRef>(null);

    // 项目详情之外的路径，使用时可以设置
    const getProjectDetail = async id => {
      const { data } = await projectDetailApi({
        id
      });
      await setBaseData(data);
    };

    const tabNames = ref(createTabNames());

    return {
      formIframeFalg,
      baseData,
      setBaseData,
      initBaseData,
      baseFormRef,
      clearStore,
      getProjectDetail,
      tabNames
    };
  },
  {
    persist: {
      storage: sessionStorage
    }
  }
);
